import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

import {
  ImageDetailsWrapper,
  SingleImagePanel,
  ThumbnailImageWrapper,
  ThumbnailsSection
} from './styles'

export const GallerySingleLoading = () => {
  const thumbnails = new Array(20).fill(1)
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      height="100%"
    >
      <SingleImagePanel className="--is-loading-state">
        <SkeletonLoader height="100%" />
      </SingleImagePanel>
      <Box display="flex" flexDirection="column">
        <ImageDetailsWrapper />
        <ThumbnailsSection>
          <Box display="flex" gap="s400" alignItems="center" padding="s500">
            {thumbnails.map((_, index) => (
              <ThumbnailImageWrapper key={`thumbnail-${index}`}>
                <SkeletonLoader width={60} height="100%" />
              </ThumbnailImageWrapper>
            ))}
          </Box>
        </ThumbnailsSection>
      </Box>
    </Box>
  )
}
